<template>
  <div>
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 70px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
      v-loading="loading"
    >
      <div
        style="
          height: 40px;
          display: flex;
          font-size: 18px;
          font-weight: bold;
          align-items: center;
        "
      >
        <div style="color: #000">
          <span
            style="cursor: pointer"
            @click="
              $router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)
            "
            >{{ backName || '工作台' }}</span
          >
          <i class="el-icon-arrow-right"></i>
        </div>
        <div style="color: #606266" class="ellipsis">供应商统计</div>
      </div>
      <div class="df" v-loading="loading">
        <el-card style="height: 110px; width: 20%">
          <div
            style="display: flex; align-items: center; flex-wrap: wrap"
            class="wh100"
          >
            <div
              style="width: 100%"
              class="projectText ellipsis"
              :title="SupplierInfo.Code"
            >
              供应商名称：{{ SupplierInfo.cVenName }}
            </div>
            <div
              style="width: 100%"
              class="projectText ellipsis"
              :title="SupplierInfo.cVenPerson"
            >
              联系人：{{ SupplierInfo.cVenPerson }}
            </div>
            <div
              style="width: 100%"
              class="projectText ellipsis"
              :title="SupplierInfo.cVenPhone"
            >
              联系人手机号：{{ SupplierInfo.cVenPhone }}
            </div>
          </div>
        </el-card>
        <el-card
          style="height: 110px; width: 250px; position: relative"
          :body-style="{
            padding: 0,
          }"
        >
          <div
            style="width: 100%; height: calc(100%); margin-top: 30px"
            id="DeviceProgress"
          ></div>
          <div
            style="
              height: 30px;
              width: 100%;
              position: absolute;
              top: 0;
              left: 0;
              text-align: center;
              font-weight: bold;
              font-size: 18px;
              line-height: 30px;
            "
          >
            提交率<span class="hint-text"  v-if="SupplyType == '1'">(乙供+分包)</span
            ><span class="hint-text" v-if="SupplyType == '3'">(甲供)</span>
          </div>
        </el-card>

        <el-card
          style="height: 110px; width: 250px; position: relative"
          :body-style="{
            padding: 0,
          }"
        >
          <div
            style="width: 100%; height: calc(100%); margin-top: 30px"
            id="DocumentProgress"
          ></div>
          <div
            style="
              height: 30px;
              width: 100%;
              position: absolute;
              top: 0;
              left: 0;
              text-align: center;
              font-weight: bold;
              font-size: 18px;
              line-height: 30px;
            "
          >
            通过率<span class="hint-text" v-if="SupplyType == '1'"
              >(乙供+分包)</span
            ><span class="hint-text" v-if="SupplyType == '3'">(甲供)</span>
          </div>
        </el-card>

        <div style="height: 110px; width: calc(80% - 500px); display: flex">
          <el-card
            style="width: 25%; height: 100%"
            body-style="padding: 0px 10px"
          >
            <div class="wh100 df aic juc" style="padding: 0px 5px">
              <div class="leftNum">
                <div
                  class="ellipsis num w100 tac"
                  :title="`${Math.round(
                    Number(dataStatistics.DeviceSubQty || 0)
                  )}/${Math.round(Number(dataStatistics.DeviceQty || 0))}`"
                >
                  <span style="font-size: 18px">{{
                    Math.round(Number(dataStatistics.DeviceSubQty || 0))
                  }}</span
                  >/{{ Math.round(Number(dataStatistics.DeviceQty || 0)) }}
                </div>
                <div class="w100 tac">
                  <span style="font-size: 12px">提交数/总数</span>
                </div>
              </div>
              <div class="rightNum" style="color: #e6a23c">
                <div class="w100 tac">
                  <i
                    class="icon-shebei icon"
                    style="color: #e6a23c; font-size: 24px"
                  ></i>
                </div>
                <div class="w100 tac">设备</div>
              </div>
            </div>
          </el-card>

          <el-card
            style="width: 25%; height: 100%"
            body-style="padding: 0px 10px"
          >
            <div class="wh100 df aic juc" style="padding: 0px 10px">
              <div class="leftNum">
                <div
                  class="ellipsis num w100 tac"
                  :title="`${Math.round(
                    Number(dataStatistics.SupplierSubQty || 0)
                  )}/${Math.round(Number(dataStatistics.SupplierQty || 0))}`"
                >
                  <span style="font-size: 18px">{{
                    Math.round(Number(dataStatistics.SupplierSubQty || 0))
                  }}</span
                  >/{{ Math.round(Number(dataStatistics.SupplierQty || 0)) }}
                </div>
                <div class="w100 tac">
                  <span style="font-size: 12px">提交数/总数</span>
                </div>
              </div>
              <div class="rightNum" style="color: #bfa170">
                <div class="w100 tac">
                  <i
                    class="icon-gongyingshang1 icon"
                    style="font-size: 24px"
                  ></i>
                </div>
                <div class="w100 tac">供应商</div>
              </div>
            </div>
          </el-card>
          <el-card
            style="width: 25%; height: 100%"
            body-style="padding: 0px 10px"
          >
            <div class="wh100 df aic juc" style="padding: 0px 10px">
              <div class="leftNum">
                <div
                  class="ellipsis num w100 tac"
                  :title="`${Math.round(
                    Number(dataStatistics.DataSubData || 0)
                  )}/${Math.round(Number(dataStatistics.DataQty || 0))}`"
                >
                  <span style="font-size: 18px">{{
                    Math.round(Number(dataStatistics.DataSubData || 0))
                  }}</span
                  >/{{ Math.round(Number(dataStatistics.DataQty || 0)) }}
                </div>
                <div class="w100 tac">
                  <span style="font-size: 12px">提交数/总数</span>
                </div>
              </div>
              <div class="rightNum" style="color: #409eff">
                <div class="w100 tac">
                  <i class="el-icon-tickets" style="font-size: 24px"></i>
                </div>
                <div class="w100 tac">资料</div>
              </div>
            </div>
          </el-card>
          <el-card
            style="width: 25%; height: 100%"
            body-style="padding: 0px 10px"
          >
            <div class="wh100 df aic juc" style="padding: 0px 10px">
              <div class="leftNum">
                <div
                  class="ellipsis num w100 tac"
                  :title="`${Math.round(
                    Number(dataStatistics.SparePartsSubQty || 0)
                  )}/${Math.round(Number(dataStatistics.SparePartsQty || 0))}`"
                >
                  <span style="font-size: 18px">{{
                    Math.round(Number(dataStatistics.SparePartsSubQty || 0))
                  }}</span
                  >/{{ Math.round(Number(dataStatistics.SparePartsQty || 0)) }}
                </div>
                <div class="w100 tac">
                  <span style="font-size: 12px">提交数/总数</span>
                </div>
              </div>
              <div class="rightNum" style="color: #6bc1c1">
                <div class="w100 tac">
                  <i class="el-icon-menu" style="font-size: 24px"></i>
                </div>
                <div class="w100 tac">配件</div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
      <!-- 统计  -->
      <el-card
        style="width: 100%; margin-top: 10px; box-sizing: border-box"
        body-style="padding: 0px 10px"
      >
        <el-tabs v-model="tabsStatistics" style="height: 100%">
          <el-tab-pane label="工作统计" name="Statistics">
            <el-card
              style="
                width: 100%;
                height: 250px;
                position: relative;
                padding: 0px 10px;
              "
              :body-style="{
                padding: 0,
              }"
              v-loading="ProjectCountLoading"
            >
              <div
                style="width: 100%; height: calc(100%)"
                id="DocumentBar"
              ></div>
            </el-card>

            <el-card
              style="
                width: 100%;
                position: relative;
                padding: 20px;
                min-height: 400px;
              "
              body-style="padding: 0px;width:100%;height:100%"
              v-loading="SupplierCountLoading"
              v-if="SupplyType == '1'"
            >
              <div
                style="
                  height: 30px;

                  position: absolute;
                  top: 20px;
                  left: 20px;
                  text-align: center;
                  font-weight: bold;
                  font-size: 18px;
                  line-height: 30px;
                "
              >
                供应商提交率/通过率<span class="hint-text">(乙供+分包)</span>
              </div>
              <div
                :style="{ width: '100%', height: supplierBarHeight + 'px' }"
                id="SupplierBar"
              ></div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="设备信息清单" name="sb">
            <!-- <ScheduleDocument
              ref="ScheduleDocument"
              v-if="tabsStatistics === 'zl'"
            ></ScheduleDocument> -->
            <ScheduleList
              ref="ScheduleList"
              v-if="tabsStatistics === 'sb'"
            ></ScheduleList>
          </el-tab-pane>
          <el-tab-pane label="设备资料清单" name="zl">
            <ScheduleDocument
              ref="ScheduleDocument"
              v-if="tabsStatistics === 'zl'"
            ></ScheduleDocument>
          </el-tab-pane>
          <el-tab-pane label="配件清单" name="bj">
            <Spare ref="Spare" v-if="tabsStatistics === 'bj'"></Spare>
          </el-tab-pane>
          <el-tab-pane label="资质清单" name="zz">
            <TeamAudiList
              ref="TeamAudiList"
              v-if="tabsStatistics === 'zz'"
            ></TeamAudiList>
          </el-tab-pane>
          <el-tab-pane label="项目资料清单" name="xm" v-if="SupplyType == '1'">
            <ProjectDocumentList
              ref="ProjectDocumentList"
              v-if="tabsStatistics === 'xm'"
            ></ProjectDocumentList>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as echarts from 'echarts'
import Spare from './Spare'
import ScheduleDocument from './ScheduleDocument'
import ScheduleList from './ScheduleList'
import ProjectDocumentList from './ProjectDocumentList'
import TeamAudiList from './TeamAudiList'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      dataStatistics: {},
      SupplierInfo: {},
      SupplierInfoLoading: false,
      loading: false,
      pId: '',
      backName: '',
      SupplierId: '',
      tabsStatistics: 'Statistics',
      ProjectCountLoading: false,
      ProjectCount: [],
      supplierBarHeight: 300,
      SupplierCountLoading: false,
      SupplierCount: [],
      SupplyType: '',
    }
  },
  props: {},
  components: {
    ScheduleDocument,
    Spare,
    ScheduleList,
    ProjectDocumentList,
    TeamAudiList,
  },
  methods: {
    getSupplierCount() {
      this.SupplierCountLoading = true
      this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectSupplierData?ProjectId=${this.pId}&SupplierId=${this.SupplierId}`,
          {}
        )
        .then((res) => {
          this.SupplierCountLoading = false
          if (res.Success) {
            this.SupplierCount = res.Data

            // 根据供应商数量动态计算高度
            let supplierCount = 0
            if (this.SupplierCount && this.SupplierCount.length > 0) {
              supplierCount = this.SupplierCount[0]?.value?.length || 0
            }

            // 动态计算图表容器高度: 基础高度200px + 每个供应商80px
            // 最小高度400px，无最大高度限制
            this.supplierBarHeight = Math.max(400, 200 + supplierCount * 80)

            // 使用多重 nextTick 确保 DOM 完全更新
            this.$nextTick(() => {
              this.$nextTick(() => {
                // 延迟一小段时间确保容器高度已经应用
                setTimeout(() => {
                  this.initSupplierChart(supplierCount)
                }, 100)
              })
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    initSupplierChart(supplierCount) {
      const barDom = document.getElementById('SupplierBar')
      if (!barDom) {
        console.warn('SupplierBar DOM element not found')
        return
      }

      // 销毁已存在的图表实例
      if (this.supplierChart) {
        this.supplierChart.dispose()
      }

      // 确保容器有正确的高度
      barDom.style.height = this.supplierBarHeight + 'px'

      this.supplierChart = echarts.init(barDom)

      // 根据供应商数量调整grid配置
      const gridBottom = supplierCount > 10 ? 80 : 50

      const baroption = {
        // title: {
        //   text: '供应商提交率/通过率',
        //   left: 'left',
        //   top: 10,
        // },
        legend: {
          data: [],
          top: 20,
        },
        grid: {
          top: 80,
          left: 150,
          bottom: gridBottom,
          right: 80,
        },
        tooltip: {
          appendToBody: true,
          trigger: 'item',
          formatter: '{b} <br/>{a} : {c}%',
        },
        label: {
          show: true,
          position: 'right',
          formatter: `{c}%`,
        },
        xAxis: {
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value} %',
          },
          show: true,
          type: 'value',
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
          },
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            show: true,
            interval: 0,
            lineHeight: 16,
            width: 100,
            overflow: 'break',
          },
          data: [],
        },
        series: [],
      }

      this.SupplierCount.forEach((item, index) => {
        if (index == 0) {
          item.value.forEach((val) => {
            baroption.yAxis.data.push(val.name)
          })
        }
        baroption.legend.data.push(item.name)
        baroption.series.push({
          name: item.name,
          type: 'bar',
          showBackground: true,
          barGap: '30%',
          barWidth: 30,
          itemStyle: {
            shadowColor: 'rgba(0, 0, 0, 0.5)',
            shadowBlur: 5,
            color: index == 0 ? '#409EFF' : '#67C23A',
          },
          data: [...item.value],
        })
      })

      this.supplierChart.setOption(baroption)

      // 强制 resize 确保图表占满容器
      setTimeout(() => {
        this.supplierChart.resize()
      }, 50)

      // 监听窗口大小变化，重新调整图表大小
      if (!this.resizeListener) {
        this.resizeListener = () => {
          if (this.supplierChart) {
            this.supplierChart.resize()
          }
        }
        window.addEventListener('resize', this.resizeListener)
      }
    },
    getSupplierInfo() {
      this.SupplierInfoLoading = true
      this.$http
        .post(`/Base_ProjectWork/Base_ProjectSupplier/GetTheData`, {
          id: this.SupplierId,
        })
        .then((res) => {
          this.SupplierInfoLoading = false
          if (res.Success) {
            this.SupplierInfo = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getdataStatistics() {
      this.loading = true
      this.$http
        .post(`/Base_ProjectWork/Base_Project/GetProjectSupplierStatistics`, {
          Search: {
            ProjectId: this.pId,
            SupplierId: this.SupplierId,
          },
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.dataStatistics = res.Data
            this.$nextTick(() => {
              for (let index = 0; index < 2; index++) {
                var chartDom = document.getElementById(
                  index == 0 ? 'DeviceProgress' : 'DocumentProgress'
                )
                var myChart = echarts.init(chartDom)
                var option
                option = {
                  tooltip: {
                    appendToBody: true,
                    formatter: '{a} : {c}%',
                  },
                  series: [
                    {
                      name: index == 0 ? '提交率' : '通过率',
                      type: 'gauge',
                      startAngle: 180,
                      endAngle: 360,
                      min: 0,
                      max: 100,
                      splitNumber: 10,
                      radius: '100%',
                      progress: {
                        show: true,
                        width: 5, //进度条宽度
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },

                        roundCap: true,
                      },
                      // 外层轴线
                      axisLine: {
                        lineStyle: {
                          width: 5,
                        },
                      },
                      axisTick: {
                        //刻度线
                        show: true,
                        distance: 1,
                        length: 2,
                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      splitLine: {
                        //表盘内刻度文字上刻度线
                        distance: 1,
                        show: true, // 显示分割线
                        length: 4, // 分割线长度，可以根据需要调整

                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      axisLabel: {
                        //表盘内刻度文字
                        distance: 6,
                        color: '#999',
                        fontSize: 8,
                      },
                      // center: ["50%", "50%"],
                      // radius: "90%",
                      pointer: {
                        width: 2, // 指针宽度，可以根据需要调整
                        length: '70%', // 指针长度，可以根据需要调整为百分比或具体数值
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },
                      },
                      detail: {
                        formatter: '{value}%',
                        textStyle: {
                          fontSize: 12,
                          color: '#333',
                        },

                        offsetCenter: [0, 10], // 详细指标位置，可以根据需要调整
                      },

                      data: [
                        {
                          value:
                            index == 0
                              ? this.dataStatistics.SubmissionRate || 0
                              : this.dataStatistics.PassRate || 0,
                          // name: index == 0 ? "设备提交率" : "文档通过率",
                        },
                      ],
                    },
                  ],
                }
                console.log(option, 'option')
                console.log(myChart, 'myChart')
                option && myChart.setOption(option)
                console.log(
                  '0000000000000000000000000000000000000000000000000000000000000000'
                )
              }
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getProjectCount() {
      this.ProjectCountLoading = true
      this.$http
        .post(
          `/Base_ProjectWork/Base_Project/GetProjectSupplierCount?ProjectId=${this.pId}&SupplierId=${this.SupplierId}`,
          {}
        )
        .then((res) => {
          this.ProjectCountLoading = false
          if (res.Success) {
            this.ProjectCount = res.Data || []
            this.$nextTick(() => {
              var barDom = document.getElementById('DocumentBar')
              var barChart = echarts.init(barDom)
              var baroption
              baroption = {
                title: {
                  text: '设备分类提交率/通过率',
                  left: 'left',
                  top: 10,
                },
                legend: {
                  data: [],
                  top: 10,
                },
                grid: {
                  top: 60,
                  left: 60,
                  bottom: 40,
                  right: 40,
                },
                tooltip: {
                  appendToBody: true,
                  trigger: 'item',
                  formatter: '{b} <br/>{a} : {c}%',
                },
                label: {
                  show: true,
                  position: 'top',
                  formatter: `{c}%`,
                },
                xAxis: {
                  type: 'category',
                  axisLabel: {
                    // 坐标轴刻度标签的相关设置。
                    show: true,
                    interval: 0,
                  },
                  data: [],
                },
                yAxis: {
                  min: 0,
                  max: 100,
                  axisLabel: {
                    formatter: '{value} %',
                  },

                  show: true,
                  type: 'value',
                  axisLine: {
                    //坐标轴轴线
                    show: true,
                  },
                  axisTick: {
                    //坐标轴刻度
                    show: true,
                  },
                },

                series: [],
              }
              this.ProjectCount?.forEach((item, index) => {
                if (index == 0) {
                  item.value.forEach((val) => {
                    baroption.xAxis.data.push(val.name)
                  })
                }
                baroption.legend.data.push(item.name)
                baroption.series.push({
                  name: item.name,
                  type: 'bar',
                  showBackground: true,
                  barGap: '60%',
                  barWidth: 30,
                  itemStyle: {
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                    shadowBlur: 10,
                    color: index == 0 ? '#409EFF' : '#67C23A',
                  },
                  // color: {
                  //   type: "linear",
                  //   x: 0,
                  //   y: 1,
                  //   x2: 0,
                  //   y2: 0,
                  //   colorStops: [
                  //     {
                  //       offset: 0,
                  //       color: "#409EFF", // 0% 处的颜色
                  //     },
                  //     {
                  //       offset: 0.5,
                  //       color: "yellow", // 100% 处的颜色
                  //     },
                  //     {
                  //       offset: 1,
                  //       color: "#fff", // 100% 处的颜色
                  //     },
                  //   ],
                  // },

                  data: [...item.value],
                })
              })
              baroption && barChart.setOption(baroption)
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    $route: {
      handler(n, o) {
        this.pId = n.query.id
        if (n.query.ParentId === this.SupplierId) {
          return
        }
        this.SupplierId = n.query.ParentId || ''
        this.SupplyType = n.query.SupplyType || ''
        this.backName = window.localStorage.getItem('ProjectName') || ''

        this.tabsStatistics = 'Statistics'

        this.getdataStatistics()
        this.getSupplierInfo()
        this.getProjectCount()
        if (this.SupplyType == '1') {
          this.getSupplierCount()
        }

        // this.getTotalInfo()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}

.head {
  height: 70px;
  // border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-drawer__header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}
::v-deep .el-pagination__total {
  font-weight: bold;
  font-size: 18px !important;
}
::v-deep .headData .el-card__body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-card__body {
  width: 100%;
  height: 100%;
}
.leftNum {
  width: calc(100% - 52px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  .num {
    font-size: 22px;
  }
}
.rightNum {
  width: 52px;
  flex-wrap: wrap;
}
.projectText {
  font-size: 12px;
  color: #909399;
}
::v-deep .el-tabs__content {
  height: calc(100% - 36px);
  .el-tab-pane {
    height: 100%;
  }
}
</style>
